import React, { Component } from 'react'
import { Activity, Article, Download } from "../components";

export class News extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bc : false,
        };
    }

    componentDidMount() {
        this.setBreadcrumb()
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.update===true){
            
        }
        
        this.setBreadcrumb()
    }

    setBreadcrumb(){
        const { main } = this.props
        const { bc } = this.state
        const { setBreadcrumb } = this.props

        if(bc===false){
            var title = (main.language)? main.language.MENU_NEWS : "-"

            setBreadcrumb(title, [{name:title, link:"/news"}])
            this.setState({ bc:true })
        }
    }

    render() {
        return (
            <main>
                <div role="main" className="main">
                    <Activity {...this.props} />
                    <Article {...this.props} />
                    <Download {...this.props} />
                </div>
            </main>
        )
    }
}

export default News
